/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuTab } from '@neutron/react';

interface IDropdownProps {
  isHelpDropdownOpen?: boolean;
  showPopover?: boolean;
}

interface IPopContentProps {
  justify?: string;
}

interface IPopItemProps {
  disabled?: boolean;
}

interface IReportDropProps {
  showReportDropdown: boolean;
}

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const InlineRelativeContainer = styled.div`
  display: inline-flex;
  position: relative;
`;

export const DropDownContainer = styled.div<IDropdownProps>`
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  border-radius: 5px;
  margin: 0px 10px;
  width: 12rem;
  z-index: 25;
  position: absolute;
  background: white !important;
  min-height: max-content;
  opacity: 1;
  display: ${props => (props.showPopover ? 'block' : 'none')};
`;

export const EmployeeDropDownContainer = styled.div<IReportDropProps>`
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  border-radius: 5px;
  margin: 0px 10px;
  width: 16rem;
  z-index: 25;
  position: absolute;
  left: -112px;
  background: white !important;
  opacity: 1;
  display: ${props => (props.showReportDropdown ? 'block' : 'none')};
`;

export const HelpDropDownContainer = styled(DropDownContainer)`
  width: 16rem;
  top: 72px;
  left: -92px;
`;

export const QuickLinksDropDownContainer = styled(DropDownContainer)`
  width: 16rem;
  top: 72px;
  left: -130px;
`;

export const ReportDropDownContainer = styled.div<IReportDropProps>`
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  border-radius: 5px;
  margin: 0px 10px;
  width: 16rem;
  z-index: 25;
  position: absolute;
  top: 72px;
  left: -112px;
  background: white !important;
  min-height: max-content;
  opacity: 1;
  display: ${props => (props.showReportDropdown ? 'block' : 'none')};
`;

export const SupportDropDownContainer = styled.div<IReportDropProps>`
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  border-radius: 5px;
  margin: 0px 10px;
  width: 16rem;
  z-index: 25;
  position: absolute;
  top: 72px;
  left: -112px;
  background: white !important;
  min-height: max-content;
  opacity: 1;
  display: ${props => (props.showReportDropdown ? 'block' : 'none')};
`;

export const ValidationDropDownContainer = styled.div<IReportDropProps>`
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  border-radius: 5px;
  margin: 0px 10px;
  width: 16rem;
  z-index: 25;
  position: absolute;
  top: 72px;
  left: -112px;
  background: white !important;
  min-height: max-content;
  opacity: 1;
  display: ${props => (props.showReportDropdown ? 'block' : 'none')};
`;

export const StyledNavTab = styled(NeuTab)`
  font-size: 0.9375rem !important;
  flex-direction: column;
  justify-content: center;
  padding-left: 0.6rem !important;
  padding-right: 0.6rem !important;
  &:active,
  &:hover {
    --link-background: transparent !important;
  }
`;

export const PopContent = styled.div<IPopContentProps>`
  display: flex;
  align-items: center;
  justify-content: ${props =>
    props.justify ? props.justify : 'space-between'};
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: var(--primary-60);
`;

export const PopItem = styled.div<IPopItemProps>`
  color: var(--primary-60);
  font-weight: bold;
  ${({ disabled }) =>
    disabled
      ? `
  background-color: transparent !important;
  cursor: auto;
  > * {
      color: var(--neu-gray-40) !important;
  }`
      : ''};
`;
